// What every field that writes a MESSAGE carries (the composer, the thread reply — the same
// Composer —, the inline edit, the forward comment): Apple's "nothing rewrites what the user typed"
// rule (ComposeTextView: autocorrection and inline completion off) plus the phone keyboard's
// sentence capitalisation (Android's KeyboardCapitalization.Sentences). The spell-check underline
// stays: it marks, it never rewrites.
//
// `autocorrect` is Safari/iOS; `writingsuggestions` is Chrome's inline completion (127+), passed
// through as a plain attribute (React 19 forwards unknown lowercase attributes).
import type { TextareaHTMLAttributes } from 'react';

export const MESSAGE_ENTRY_ATTRIBUTES = {
  autoCapitalize: 'sentences',
  autoCorrect: 'off',
  autoComplete: 'off',
  spellCheck: true,
  writingsuggestions: 'false',
} as TextareaHTMLAttributes<HTMLTextAreaElement>;
